import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button, Menu, MenuItem} from '@material-ui/core';
import converter from '../../../Helper/convertFile';
import {DeleteUserOwnFeed, fetchAlbum} from '../../../Actions/albumActions';
import Alert from '../../../Helper/SimpleAlert/alert';
import Loader from '../../../Helper/loader/loader';
import Camera from '../Messages/WebView/Gif';
import './album.css';

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    input: {
        display: 'none',
    },
    button: {
        fontSize: '20px',
        fontWeight: 'bold',
        borderRadius: '12px',
        width: '200px',
        fontFamily: 'Ropa Sans',
        textTransform: 'capitalize',
        marginTop: '15px',
    },
    firstRefresh: {
        display: 'inline-block',
        position: 'relative',
        width: '80px !important',
        height: '80px !important',
        marginTop: '100px',
        color: '#a534a6'
    },
    refresh: {
        display: 'inline-block',
        position: 'relative',
        width: '40px !important',
        height: '40px !important',
        marginTop: '15px',
        color: '#a534a6'
    },
    menuItem: {
        fontSize: 20,
        width: 168
    }
});

class AlbumWebView extends React.Component {
    constructor() {
        super();
        this.state = {
            feedId: '',
            data: [],
            files: [],
            src: '',
            showAlert: false,
            showError: false,
            pageIndex: 2,
            uploadImage: false,
            showMenu: false,
            openCamera: false,
            Msg: ""
        }
    }

    loadOnScroll = (e) => {

        // console.log(e.target)
        let {pageIndex} = this.state;
        let {albumData} = this.props;
        let {AppUser} = this.props.user.results;
        let {scrollHeight, scrollTop, clientHeight} = e.target;
        // console.log(scrollHeight,scrollTop,clientHeight)
        if (albumData.album.TotalRecords === albumData.albumLength) return;
        let isAtEnd = false;
        if (clientHeight + scrollTop >= scrollHeight) {
            isAtEnd = true;
        }
        if (isAtEnd) {
            let data = {
                UserId: AppUser.UserId,
                PageSize: 30,
                PageNumber: pageIndex,
                Latitude: AppUser.Latitude,
                Longitude: AppUser.Longitude
            };
            this.props.fetchAlbum(data);
            pageIndex = pageIndex + 1;
            this.setState({pageIndex});
        }
    };
    handleFileChange = (e) => {
        //e.stopPropagation();
        let Arr = [];
        e.preventDefault();
        e.stopPropagation();
        converter.toBase64(e.target.files[0]).then((dt) => {
            Arr.push(dt)
        })
        this.setState({
            data: Arr,
            files: e.target.files[0]
        }, () => {
            setTimeout(() => {
                this.formHandler()
            }, 1000)
        })
        e.target.value = '';
    };
    handleCameraClick = (image) => {
        const {user, callApi} = this.props;
        image = image.substring(image.indexOf(',') + 1);
        let imageData = {
            'UserId': user.results.AppUser.UserId,
            'Latitude': user.results.AppUser.Latitude,
            'FeedType': 'LocalFeed',
            'PostComment': "",
            'Longitude': user.results.AppUser.Longitude,
            'Image': image,
            'FeedSendType': 'LocalFeed',
            'isImage': 'NO',
            'isVideo': 'YES',
            'friendIdList': "",
            'phoneContactNameList': "",
            'locationAddress': "",
            'placeId': "",
            'sharedWithId': "",
            'placePhone': "",
            'placeWebsite': "",
            'sendFeedType': ""
        };
        callApi(imageData);
        this.toggleMenu();
    };

    formHandler = () => {
        let {data, files} = this.state;
        let totalData = {
            data: data,
            files: files
        };
        this.props.onUpload(totalData, 'Add');
    };

    show = (src) => {
        let modal = document.getElementById('myModal');
        modal.style.display = "block";
        this.setState({
            src: src
        });
    };
    toggleMenu = () => {

        this.setState({
            showMenu: !this.state.showMenu
        });
    };

    closes = () => {
        let modal = document.getElementById('myModal');
        modal.style.display = "none";
        this.setState({
            src: ''
        })
    };

    checkFormat = (url) => {
        let arr = url.split('.');
        return arr[arr.length - 1];
    };

    DeleteUserOwnFeed = (v) => {
        this.props.DeleteUserOwnFeed({FeedId: v.feedDetail.FeedId, UserId: this.props.user.results.AppUser.UserId});
        this.showAlert("Image Deleted Successfully.");
    };

    showAlert = (msg) => {
        let {showAlert} = this.state;
        showAlert = !showAlert;
        let Msg = msg
        this.setState({
            showAlert,
            Msg
        });
    };

    toggleCamera = () => {
        this.setState({
            openCamera: !this.state.openCamera
        });
    };

    render() {
        const {classes, albumData, showGotIt, showError} = this.props;
        const {src, showAlert, showMenu, openCamera} = this.state;
        return (
            <React.Fragment>
                {openCamera && <Camera
                    showCamera={openCamera}
                    toggleCamera={this.toggleCamera}
                    onCameraClick={this.handleCameraClick}
                    toggleAlert={(e) => {
                        showError(e);
                        this.toggleMenu();
                    }}
                />}
                <div
                    className={showGotIt ? "album-gallery-css" : "album-gallery-css-two"}
                    onScroll={this.loadOnScroll}>
                    <Alert showSuccess={showAlert} showError={false} Msg={this.state.Msg} onClose={this.showAlert}/>
                    <div id="myModal" className="modal" tabIndex={0}>
                        <span className="close custom-close" onClick={this.closes}>&times;</span>
                        <img className="modal-content" id="img01"
                             src={src.substring(0, 5) === "https" ? src : `data:image/jpeg;base64,${src}`}
                             style={{background: 'none'}}/>
                    </div>
                    <div className="upload-img-button">
                        <input type="file" ref="img" multiple="multiple" onChange={this.handleFileChange}
                               style={{display: 'none'}}
                               onclick={null}/>
                        <Button
                            id="upload-button"
                            onClick={this.toggleMenu}
                            className={classes.button}
                            size="medium"
                            variant={'contained'}
                            color={'primary'}
                        >
                            Upload
                        </Button>
                        <Menu open={showMenu} anchorEl={document.getElementById('upload-button')}
                              onClose={this.toggleMenu}>
                            <MenuItem
                                className={classes.menuItem}
                                onClick={() => {
                                    this.refs.img.click();
                                    this.toggleMenu();
                                }
                                }>Upload</MenuItem>
                            <MenuItem
                                className={classes.menuItem}
                                onClick={this.toggleCamera}
                            >Capture</MenuItem>
                        </Menu>
                    </div>
                    <div>
                        <div className="gallery-css" style={{position: 'relative', marginTop: '2%'}}>
                            {
                                (albumData.album.TotalRecords === 0 || albumData.albumLength === 0) &&
                                <div className="no-images-webview">Upload your first image.</div>
                            }
                            {/*{console.log("img", albumData.album.ImagesList)}*/}
                            {albumData.album && albumData.album.ImagesList && albumData.album.ImagesList.map((v, i) => {
                                return (
                                    <div className="images" key={i}>
                                        {
                                            v.ImageUrl.length > 1000 ?
                                                v.isImage === 'NO' ?
                                                    <video controls="controls" id="video">
                                                        <source src="sintel-trailer.ogv"
                                                                type='video/ogg; codecs="theora, vorbis"'/>
                                                        <source src={`data:video/mp4;base64,${v.ImageUrl}`}
                                                                type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                                                    </video>
                                                    :
                                                    <img src={`data:image/jpeg;base64,${v.ImageUrl}`} alt="uploaded"
                                                         onClick={() => {
                                                             this.show(v.OriginalImageUrl)
                                                         }}/>
                                                :
                                                (this.checkFormat(v.ImageUrl)) !== 'jpeg' ?
                                                    <video controls="controls" id="video">
                                                        <source src="sintel-trailer.ogv"
                                                                type='video/ogg; codecs="theora, vorbis"'/>
                                                        <source src={v.ImageUrl}
                                                                type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                                                    </video>
                                                    :
                                                    <img src={v.ImageUrl} alt="uploaded" onClick={() => {
                                                        this.show(v.OriginalImageUrl)
                                                    }}/>
                                        }
                                        <img src={require('../../../images/closeicon.png')}
                                             className="close-window-icon" onClick={() => {
                                            this.DeleteUserOwnFeed(v)
                                        }}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    {
                        albumData.album.TotalRecords !== undefined
                            ?
                            albumData.album.TotalRecords > albumData.albumLength ?
                                <div className="app-Loader"><Loader/></div>
                                :
                                <React.Fragment/>
                            :
                            <div className="app-Loader">
                                <Loader/>
                            </div>
                    }
                </div>
            </React.Fragment>
        )
    }
}

AlbumWebView.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        user: state.loginResponse,
        albumData: state.albums,
    }
};
const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        DeleteUserOwnFeed,
        fetchAlbum
    }, dispatch)
};
export default connect(mapStateToProps, matchDispatchToProps)(withStyles(styles)(AlbumWebView));